import React from 'react'
import type { ReactNode } from 'react'
import RightCheckQuizIcon from 'shared/icons/right-check-quiz-icon'
import SquareIcon from 'shared/icons/square-icon'
import { cwd } from 'shared/utils/class-name-with-modifiers'
import { CourseQuizDataInProgressInterface } from 'modules/course/types/course-quiz-interface'
import { addPublicCustomClassNamePrefix } from 'modules/course/utils/add-class-prefix'
import { AnswersListWrapper } from '../answer-list/answer-list-wrapper'
import { AnswersListItem } from '../answer-list/answers-list-item'
import { AnswersText } from '../answer-list/answers-text'

interface AnswersListProps {
  selectedAnswers: Array<boolean> | undefined
  answers: CourseQuizDataInProgressInterface['q'][0]['a']
  onClick: (index: number) => void
  className?: string
}

export const AnswersList = ({
  answers,
  className,
  selectedAnswers,
  onClick,
}: React.PropsWithChildren<AnswersListProps>): ReactNode => {
  return (
    <AnswersListWrapper className={className}>
      {answers.map((answer, index) => {
        const isSelected = !!(selectedAnswers && selectedAnswers[index])
        return (
          <AnswersListItem
            key={index}
            as="button"
            className={`cursor-pointer hover:border-solid hover:text-THEME-hover-primary ${cwd(
              addPublicCustomClassNamePrefix('course-quiz__in-progress-answer'),
              {
                ['selected']: !!isSelected,
              },
            )}`}
            restProps={{
              onClick: () => {
                onClick(index)
              },
            }}
          >
            <div className="mt-1">
              {selectedAnswers && selectedAnswers[index] ? (
                <RightCheckQuizIcon className="shrink-0 fill-THEME-primary" />
              ) : (
                <SquareIcon className="shrink-0 [&>path]:stroke-THEME-disabled [&>path]:stroke-[1px]" />
              )}
            </div>
            <AnswersText dangerouslySetInnerHTML={{ __html: answer.t }} />
          </AnswersListItem>
        )
      })}
    </AnswersListWrapper>
  )
}
